import React from "react";
import { useTranslation } from "react-i18next";
export default function ForgotPasswordPage() {
  const { t, i18n } = useTranslation();
  return <div>ForgotPasswordPage</div>;
}
